// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"922380be","598":"f5ff8ccf","787":"9b9c0edf"}[chunkId] + ".chunk.js";
};